import { Form, FormActions, Modal } from 'ui';
import { type ExtendedRequestJoinFormValues, RequestJoinFormContent } from './request-join-form-content';

export type RequestJoinFormValues = ExtendedRequestJoinFormValues;

type P = {
  isLoading: boolean;
  onCancel: () => void;
  onFinish: (values: RequestJoinFormValues) => Promise<void> | void;
};

const RequestJoinForm = ({ isLoading, onCancel, onFinish }: P) => (
  <Form<RequestJoinFormValues> onFinish={onFinish}>
    <RequestJoinFormContent<RequestJoinFormValues> />
    <Modal.HugContent.Footer>
      <FormActions
        right={{ children: 'Cancel', onClick: onCancel }}
        submit={{ children: 'Send', loading: isLoading }}
      />
    </Modal.HugContent.Footer>
  </Form>
);

export default RequestJoinForm;
